import { createAction } from "redux-act";

export const PlaygroundListAction = createAction("Playground List");
export const PlaygroundListRequestAction = createAction("Playground List - Request");
export const PlaygroundListSuccessAction = createAction("Playground List - Success");
export const PlaygroundListFailedAction = createAction("Playground List - Failed");
